import {
	KnowledgeDiscoveryJiraIntentDetectionModel,
	type KnowledgeDiscoveryJiraIntentDetectionModelType,
} from '@atlassian/search-client/knowledge-discovery/types';

export const modelIdValidator = (
	modelId?: string,
): modelId is KnowledgeDiscoveryJiraIntentDetectionModelType => {
	if (!modelId) {
		return false;
	}

	const intentDetectionModel = Object.values(KnowledgeDiscoveryJiraIntentDetectionModel);
	return Boolean(intentDetectionModel.find((x) => x === modelId));
};
